module.exports = __webpack_public_path__ + "static/media/domestic_request.bc2de514.svg";